<template>
  <div id="intro">
    <section class="hero has-text-centered is-dark has-background">
      <img class="hero-background is-transparent" src="@/assets/grayscaled37.jpg" />
      <div class="hero-body">
        <div class="container">
          <img src="@/assets/detectx_round.png" />
          <h2 class="subtitle">
            <p>Automated Threat Detection by AI</p>
          </h2><br>

          <div v-show="!profileIcon" @click="login">
            <img width="200px" src="@/assets/btn_google_signin_light_normal_web@2x.png"/>
          </div>
          <div v-show="profileIcon" @click="goToProduct('#aboutdetectx')">
            <a class="button">Learn More</a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import helper from '@/helper'

export default {
  computed: {
    profileIcon() {
      return helper.profileIcon()
    }
  },
  methods: {
    login () {
      return helper.firestoreLogin()
    },
    goToProduct (val) {
      location.hash = val
    }
  }
}
</script>

<style>
.hero.has-background {
  position: relative;
  overflow: hidden;
}
.hero-background {
  position: absolute;
  object-fit: cover;
  object-position: center center;
  width: 100%;
  height: 100%;
}
.hero-background.is-transparent {
  opacity: 0.3;
}

</style>
